export const TESTIMONIAL_DATA = [
  // Upwork reviews - Unable to fetch automatically due to JavaScript requirements. Please provide review text manually.
  {
    avatar: null,
    from: "Upwork Client",
    designation: "iOS, Software Engineer",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01de0a68581b257d7f",
    text: "Usman is an extremely talented developer who's helped me so much with pushing the project forward and more. If you're looking for a Swift professional to deliver the best possible outcomes, then this is your guy.",
    rating: 5,
    date: "2024-03-15",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "React Native Developer",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Usman did amazing work for me. We will definitely hire him again in the future.",
    rating: 5,
    date: "2024-02-28",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "iOS app debugging",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Usman delivered always exceptional performance on every single project, working on a mobile application for crypto exchange. Was my pleasure to work for one year with Usman. Bringing seniority and complexity to project management, he is able to perform complex tasks and bring new ideas and solutions for complex problems in application development. Communication was always quick and clear. I could just recommend Usman for his professionality and skillset. He is truly the senior developer you want on your team.",
    rating: 5,
    date: "2024-01-20",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "Senior React Native Developer",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Working with Usman has been an absolute pleasure. His React Native skill is great. I highly recommend him to anyone who needs a skilled and dedicated mobile developer.",
    rating: 5,
    date: "2023-12-10",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "React Native/WebRTC Expert for iOS/Android",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "I was very impressed with his work. He was able to maintain an app that met all of my requirements and he was able to complete the project on time. I would definitely recommend this freelancer to anyone looking for a talented app developer.",
    rating: 5,
    date: "2023-11-05",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "React Native image loading time optimization",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Usman helped us to optimize image loading time in our application. He was prompt, professional, knowledgeable, and committed to achieving the desired outcome.",
    rating: 5,
    date: "2023-10-15",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "Simple ios help needed",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Best ios and android coder on upwork.",
    rating: 5,
    date: "2023-09-22",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "Looking for React Native expert",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "The engagement was short, but Usman provided good suggestions on the project.",
    rating: 4,
    date: "2023-08-30",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "Submit iOS and android app",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Best ios and android developer on upwork and maybe in the world",
    rating: 5,
    date: "2023-07-18",
  },
  {
    avatar: null,
    from: "Upwork Client",
    designation: "Simple ios help needed",
    platform: "upwork",
    url: "https://www.upwork.com/freelancers/~01148f513ff72809d0",
    text: "Best iOS on upwork. Will work with him again for sure.",
    rating: 5,
    date: "2023-06-25",
  },
  // Fiverr reviews - Fetched from profile
  {
    avatar: null,
    from: "bakedbanshee",
    designation: "Repeat Client on Fiverr",
    platform: "fiverr",
    url: "https://pro.fiverr.com/freelancers/magrafay?public_mode=true",
    text: "Amazing service once again. I will continue to come back to this seller every time.",
    rating: 5,
    date: "2024-04-10",
  },
  {
    avatar: null,
    from: "bakedbanshee",
    designation: "Repeat Client on Fiverr",
    platform: "fiverr",
    url: "https://pro.fiverr.com/freelancers/magrafay?public_mode=true",
    text: "Amazing work, once again. Will continue to use magrafay.",
    rating: 5,
    date: "2023-05-15",
  },
  {
    avatar: null,
    from: "silvanaukcamaj",
    designation: "Client on Fiverr",
    platform: "fiverr",
    url: "https://pro.fiverr.com/freelancers/magrafay?public_mode=true",
    text: "Perfect and professional used for brackets.",
    rating: 5,
    date: "2023-05-20",
  },
  {
    avatar: null,
    from: "Pro Client",
    designation: "Client on Fiverr (Marketing & Advertising)",
    platform: "fiverr",
    url: "https://pro.fiverr.com/freelancers/magrafay?public_mode=true",
    text: "Very good communication.",
    rating: 5,
    date: "2023-04-28",
  },
];
